var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHeartOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "54.554px",
    height: "48.504px",
    viewBox: "0 0 54.554 48.504",
    enableBackground: "new 0 0 54.554 48.504",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 54.554,
    height: 48.504
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M37.838,3c7.563,0,13.716,6.153,13.716,13.717c0,4.171-1.868,8.066-5.126,10.689l-0.059,0.047 l-0.056,0.051L27.267,44.485L8.044,27.346l-0.04-0.035l-0.041-0.035C4.809,24.658,3,20.81,3,16.717C3,9.153,9.152,3,16.716,3 c3.195,0,6.191,1.067,8.664,3.085l1.896,1.548l1.898-1.548C31.647,4.067,34.643,3,37.838,3 M37.838,0 c-4.007,0-7.682,1.411-10.562,3.761C24.398,1.411,20.722,0,16.716,0C7.484,0,0,7.484,0,16.717c0,5.176,2.353,9.802,6.048,12.868 l21.219,18.919l21.042-18.761c3.806-3.064,6.245-7.76,6.245-13.026C54.554,7.484,47.069,0,37.838,0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeartOutline);
export default __webpack_public_path__ + "static/media/icon-heart-outline.fde7128c0634ffdbecf6740c2a0c163d.svg";
export { ForwardRef as ReactComponent };